(function() {
  var Zone,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Zone = App.loadClass("grower::viewmodels/data/management_zones/Zone");

  exports.Layer = (function(superClass) {
    extend(Layer, superClass);

    function Layer(data) {
      var i, ref, ref1, ref2, ref3, ref4, ref5, ref6, zones;
      if (data == null) {
        data = {};
      }
      this.save = bind(this.save, this);
      Layer.__super__.constructor.call(this);
      this.id = (ref = data.id) != null ? ref : null;
      this.year = (ref1 = data.year) != null ? ref1 : null;
      this.zone_type = (ref2 = data.zone_type) != null ? ref2 : null;
      this.extra_info = (ref3 = data.extra_info) != null ? ref3 : {};
      this.fields_id = (ref4 = data.fields_id) != null ? ref4 : null;
      zones = (ref5 = (ref6 = data.zone_areas) != null ? ref6 : data.areas) != null ? ref5 : [];
      this.zone_areas = (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = zones.length; j < len; j++) {
          i = zones[j];
          results.push(new Zone(this, i));
        }
        return results;
      }).call(this);
    }

    Layer.prototype.save = function(extra_data, callback) {
      var req;
      if (extra_data == null) {
        extra_data = {};
      }
      return req = $.ajax({
        url: "layers/management-zones/add",
        data: this.serialize(),
        type: 'POST',
        context: extra_data
      }).done(callback);
    };

    return Layer;

  })(KoModel);

}).call(this);
